import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PreviousPageService {
  private previousUrlStack: string[] = [];
  private openedPointFromReminder = false;

  getOpenedPointFromReminder(): boolean {
    return this.openedPointFromReminder;
  }

  setPreviousFleetUrl(url: string): void {
    if (this.previousUrlStack.at(-1) === url) {
      return;
    }

    this.previousUrlStack.push(url);
    this.openedPointFromReminder = false;
  }

  setPreviousRemindersUrl(url: string): void {
    if (this.previousUrlStack.at(-1) === url) {
      return;
    }

    this.previousUrlStack.push(url);
    this.openedPointFromReminder = false;
  }

  setPreviousPageOnReminderOpen(url: string): void {
    this.openedPointFromReminder = true;
    if (this.previousUrlStack.at(-1) === url) {
      return;
    }
    this.previousUrlStack.push(url);
  }

  setPreviousSiteUrl(url: string): void {
    this.openedPointFromReminder = false;

    if (url.includes('reminders')) {
      return;
    }
    if (this.previousUrlStack.at(-1) === url) {
      return;
    }

    this.previousUrlStack.push(url);
  }

  getPreviousUrl(): string {
    return this.previousUrlStack[this.previousUrlStack.length - 1] || '';
  }

  navToPreviousUrl(): string {
    this.openedPointFromReminder = false;
    return this.previousUrlStack.pop();
  }

  clearUrlStack(): void {
    this.previousUrlStack = [];
    this.openedPointFromReminder = false;
  }
}
